<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="功能名称:" prop="label">
          <Input v-model="formFields.label" placeholder="请输入菜单功能名称..." size="small" />
        </FormItem>
        <FormItem label="权限标识:" prop="name">
          <Input v-model="formFields.name" placeholder="请输入菜单功能权限标识..." size="small" />
        </FormItem>
        <FormItem label="功能路径:" prop="path">
          <Input v-model="formFields.path" placeholder="请输入功能路径URL..." size="small" />
        </FormItem>
        <FormItem label="功能描述:" prop="description">
          <Input v-model="formFields.description" placeholder="请输入功能描述..." size="small" />
        </FormItem>
        <FormItem label="功能方法:" prop="method">
          <Select
            v-model="formFields.method"
            clearable
            filterable
            placeholder="请选择功能请求..."
            size="small"
            @on-change="handleMethodChange"
          >
            <Option v-for="method in requestMethods" :key="method" :value="method" :label="method" />
          </Select>
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'MenuFunctionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    menuId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      rootMenus: [],
      requestMethods: ['GET', 'POST', 'DELETE', 'PATCH', 'PUT'],
      formFields: {
        name: '',
        label: '',
        path: '',
        method: '',
        id: this.id,
        menuId: this.menuId,
        description: ''
      }
    }
  },
  computed: {
    ruleValidate() {
      const validateName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('功能权限标识不能为空!'))
        }
        if (!value.trim().startsWith('PEM_')) {
          callback(new Error('功能权限标识必须以‘PEM_’开头..'))
        }
        if (value.trim() === 'PEM_') {
          callback(new Error('非法功能权限标识..'))
        }
        callback()
      }
      return {
        name: [{ required: true, validator: validateName, trigger: 'blur' }],
        label: [{ required: true, message: '功能名称不能为空!', trigger: 'blur' }],
        path: [{ required: true, message: '功能路径不能为空!', trigger: 'blur' }],
        method: [{ required: true, message: '功能请求方法不能为空!', trigger: 'change' }]
      }
    },
    isParentMenu() {
      return this.formFields.parentId !== ''
    },
    hasPath() {
      return this.formFields.path !== ''
    },
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑菜单' : '添加新菜单'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      if (this.menuId) {
        this.resetForm()
        this.loadingStatus = false
        if (this.action && this.id) {
          this.loadingStatus = true
          request({
            url: this.action + '/' + this.id,
            method: 'get'
          }).then(res => {
            this.loadingStatus = false
            this.formFields = res.data
          }).catch(error => {
            this.loadingStatus = false
            console.log(error)
          })
        }
      }
    }
  },
  methods: {
    handleMethodChange: function(val) {
    },
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
      this.formFields.menuId = this.menuId
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.action) {
            this.$refs.form.validate((valid) => {
              if (valid) {
                this.submit = true
                const isNew = this.formFields.id === 0
                request({
                  url: this.action + (isNew ? '' : ('/' + this.id)),
                  method: isNew ? 'POST' : 'PUT',
                  data: this.formFields
                }).then(res => {
                  this.loadingStatus = false
                  this.formFields = res.data
                  this.$Notice.success({
                    title: '菜单功能 `' + this.formFields.label + '` 保存成功!'
                  })
                  this.submit = false
                  this.closeModal(true)
                }).catch(error => {
                  this.loadingStatus = false
                  this.submit = false
                  console.log(error)
                })
              }
            })
          }
        }
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

